<template>
  <slot
    v-bind="{
      renderedContent,
    }"
  ></slot>
</template>

<script setup lang="ts">
defineOptions({
  name: 'CommonMdContent',
});

const props = defineProps<{
  /**
   * The content to render.
   */
  content: string;
}>();

const md = useMarkdownIt();
const renderedContent = computed(() => {
  return md.render(props.content);
});

defineSlots<{
  default: (props: { renderedContent: string }) => void;
}>();
</script>

<style scoped></style>
